import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled';
import { FormattedMessage } from '@atlassian/jira-intl';
import { TransitionHomeHeader } from '../../../common/ui/transition-home/header/index.tsx';
import { messages as stepMessages } from '../../../common/ui/transition-home/step/messages.tsx';
import { useTransitioningStatus } from '../../../services/store/transitioning-status/index.tsx';
import { CardOne } from './card-one/index.tsx';
import { CardTwo } from './card-two/index.tsx';
import { CardZero } from './card-zero/index.tsx';

export const NotificationsStep = () => {
	const [{ isRBNEnabled, ogAppExistsAtTransitioningStart, loading }] = useTransitioningStatus();

	if (loading) {
		throw new Error('NotificationsStep - Data should be loaded at this point.');
	}

	return (
		<Stack space="space.250">
			<TransitionHomeHeader
				title={<FormattedMessage {...stepMessages.notificationsTitleNonFinal} />}
				description={<FormattedMessage {...stepMessages.notificationsDescriptionNonFinal} />}
			/>

			<CardZero />
			<CardOne />
			{(ogAppExistsAtTransitioningStart || isRBNEnabled) && <CardTwo />}
		</Stack>
	);
};
